import styled from "styled-components";
import {ConfettiZIndex} from "../confetti.component.interface";

export const ConfettiContainerDefaultBox = styled.div<{animate: boolean; zIndex?: number | ConfettiZIndex;}>`
    /* Allow clicks to go through */
    pointer-events: none;
    /* Nothing is selectable */
    -webkit-user-select: none; /* Safari */
    user-select: none;
    /* Above everything else */
    z-index: ${props => props.zIndex ? props.zIndex : null };
    /* Confetti overflowing the container should not create scroll */
    overflow: hidden;
    /* Fullscreen */
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    left: 0;

    /** Enabling the animation by setting the display is better for the performance than rendering and animating directly */
    display: ${props => props.animate ? "unset" : "none"};
`;